import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Dashboard from './pages/dashboard/Dashboard'
import ShareComplete from './pages/share/ShareComplete'
import ShareLanding from './pages/share/ShareLanding'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/share-complete" element={<ShareComplete />} />
        <Route path="/share" element={<ShareLanding />} />
      </Routes>
    </Layout>
  )
}

export default App
